query QueueJobQuery($id: ID!, $queueName: String!) {
  job(id: $id, queueName: $queueName) {
    id
    name
    data
    delay
    steps
    timestamp
    progress
    result
    state
    stacktrace
    attemptsMade
    failedReason
    finishedOn
    processedOn
    logs
    opts {
      priority
      timeout
      removeOnComplete
      attempts
      backoff {
        type
        delay
      }
      delay
      timestamp
    }
  }
}
